import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState, UserLogin } from "ngx-sds-login";
import { Observable, Subject, takeUntil } from "rxjs";
import { Solicitud } from "src/app/infraestructure/interfaces/referente/SolicitudDTO";
import { ReferentApiService } from "src/app/infraestructure/services/referent/referent-api.service";
import { NgbModal, NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import { SolicitudCambiarEstadoI } from "src/app/infraestructure/models/solicitudCambiarEstado.interface";

@Component({
  selector: "app-gestion-solicitud-programador",
  templateUrl: "./gestion-solicitud-programador.component.html",
  styleUrls: ["./gestion-solicitud-programador.component.scss"],
})
export class GestionSolicitudProgramadorComponent implements OnInit {

  @ViewChild('gestion_solicitud', { static: true }) gestion_solicitud: any;

  private $topSubcription = new Subject<void>();
  user$: Observable<UserLogin>;
  solicitud: Solicitud = new Solicitud();
  $vincularSolicitud: boolean = false;
  dataSolicitud = {} as SolicitudCambiarEstadoI;

  solicitudId: number = 0;
  rolId: number = 0;
  userId: number = 0;
  submitted: number = 0;
  
  constructor(public router: Router,
              private route: ActivatedRoute, 
              private store: Store<AppState>,
              private referentApiSrv: ReferentApiService,
              config: NgbModalConfig,
              private modalService: NgbModal,
              private cdr: ChangeDetectorRef
              ) 
              { 
                this.user$ = this.store.select(state => state.user);
                this.user$.subscribe(user => {
                  this.rolId = user.rolId;
                  this.userId = user.id;
                });

                config.backdrop = 'static';
                config.keyboard = false;
                config.size = 'xl';
              }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.solicitudId = +params['id'];
      // Lógica para manejar el cambio de ID
      this.getSolicitudById(this.solicitudId);
    });
  }


  getSolicitudById(id: number) {
    if (!id) return;
    this.referentApiSrv.getSolicitudById(id)
      .pipe(takeUntil(this.$topSubcription))
      .subscribe(res => {
        if (res.code === 200) {
          this.solicitud = res.data;
        }
      });
  }

  catchRequestService(event: any) {
    console.log(event)
  }

  onCambiarEstado() {
    this.dataSolicitud.rolId = this.rolId;
    this.dataSolicitud.usuarioId = this.userId;
    this.dataSolicitud.solicitudId = this.solicitudId;
    this.dataSolicitud.accion = 'NO_PROCEDENTE';
    this.dataSolicitud.datos = {};

    this.referentApiSrv.putSolicitudCambiarestado(this.dataSolicitud)
    .pipe(takeUntil(this.$topSubcription))
      .subscribe(res => {
        if (res.code === 200) {
          this.router.navigate(['/bandeja-programador']);
        } else {
          const messages = res.errors.map((error: any) => `<li>${error.message}</li>`).join('\n');
          
          Swal.fire({
            title: 'Errores',
            icon: 'error',
            html: '<ul style="text-align: left; font-size: 0.8rem;">' + messages + '</ul>',
            showConfirmButton: true,
            confirmButtonColor: "#004884",
            confirmButtonText: "ACEPTAR",
          });
        }
      });
  }

  addNovedad(novedad: any) {
    if (novedad === 'close') return this.modalService.dismissAll(novedad);

    this.modalService.open(novedad);
  }

  modalGestion(options?: any) {
    if (options && options.idSolicitud) this.getSolicitudById(options.idSolicitud);
    if (options && options.close) return this.modalService.dismissAll(this.gestion_solicitud);
    
    this.modalService.open(this.gestion_solicitud);
  }
}
